export default __webpack_public_path__ + "static/media/battery_materials_engineer_2026.17be2bee.pdf";